import { Component, OnInit, ViewChild } from '@angular/core';
import { NgxSpinnerService } from 'ngx-spinner';
import { ConfirmationService, MenuItem } from 'primeng/api';
import { OverlayPanel } from 'primeng/overlaypanel';
import { Paginator } from 'primeng/paginator';
import { catchError, finalize, of } from 'rxjs';
import { CouponCodeService } from 'src/app/_business-dashboard/_services/bizz-coupon-codes.services';
import { SalesChannelService } from 'src/app/_business-dashboard/_services/bizz-sales-channel.services';
import { AppBaseDataService } from 'src/app/_services/app-base-data.service';
import { ConnMessageService } from 'src/app/_services/conn-message.service';
import { FilterServiceService } from 'src/app/_services/filter-service.service';
import { GlobalService } from 'src/app/_services/global.service';

@Component({
  selector: 'app-bizz-sales-channel-list',
  templateUrl: './bizz-sales-channel-list.component.html',
  styleUrls: ['./bizz-sales-channel-list.component.scss'],
})
export class BizzSalesChannelListComponent implements OnInit {
  _globals = GlobalService;
  @ViewChild('op') op: OverlayPanel;
  page = 0;
  rows = 10;
  first = 0;
  totalRecords = 0;
  dataList: any = null;
  searchText = '';
  lastSearchText = '';
  masterDataList: any = null;
  isViewOnly = false;

  orderParam = '';
  orderBy = 'asc';

  colHeader = this._abd.reports.filter(
    (x) => x.paraReportName == 'Sales Channel'
  )[0].summaryHeader;
  colflds = this._abd.reports.filter(
    (x) => x.paraReportName == 'Sales Channel'
  )[0].colflds;
  indexArray: number[] = [];
  actions: MenuItem[] = [
    { label: 'Edit', icon: 'pi pi-book' },
    { label: 'Delete', icon: 'pi pi-trash' },
    { label: 'Assign Coupon', icon: 'pi pi-ticket' },
  ];

  @ViewChild('p', { static: false }) paginator: Paginator;

  showAssignCouponDialog = false;
  selectedCoupon: any = null;
  assignedCoupons: any[] = [];
  allCoupons = [];
  filteredCoupons: any[] = [];
  selectedChannel: any = null;
  allCouponsData: any[] = []; // to hold full coupon data

  // Dialog control

  // Coupon lists
  originalCoupons: any[] = [];
  addedCoupons: any[] = [];
  removedCoupons: any[] = [];

  // For unsaved change tracking
  hasChanges = false;
  showAllCouponsDialog = false;
  selectedCoupons: any[] = [];
  errorMessage = '';
  constructor(
    public salesChannelServices: SalesChannelService,
    private _spinner: NgxSpinnerService,
    private _connMessageService: ConnMessageService,
    private _confirmationService: ConfirmationService,
    public _abd: AppBaseDataService,
    public _filterService: FilterServiceService,
    private couponCodeServices: CouponCodeService
  ) { }

  ngOnInit(): void {
    this._globals.componentName = 'Sales Channel';
  }

  ngAfterViewInit() {
    let ti = null;
    ti = setInterval(() => {
      let ppages = this._filterService.getPages(
        this._globals.componentName
      );
      if (ppages) {
        let lastpage = parseInt(ppages.page);
        if (lastpage < 0) lastpage = 0;
        if (lastpage > 0) {
          this.page = lastpage;
          this.first = lastpage * this.rows;
        }
      }
      let filter = this._filterService.getFilters(
        this._globals.componentName
      );
      if (filter) {
        if (filter.filterValue)
          this._filterService.searchText = filter.filterValue;
      }
      clearInterval(ti);
      this.getDataList();
      this.getAllCoupons();
    }, 500);
  }


  getAllCoupons() {
    const obj = {
      PageNo: this.page,
      PageSize: 2000000,
      filterValue: '',
      discountValue: null,
      orderParam: this.orderParam,
      orderBy: this.orderBy,
    };

    try {
      this.couponCodeServices.getAllCouponCodes(obj).subscribe((res) => {
        if (res.success) {
          this.totalRecords = res.totalRecords;
          this.allCoupons = [];

          res.data.forEach((coupon: any) => {
            if (coupon.couponCodesList?.length > 0) {
              coupon.couponCodesList.forEach((code: string) => {
                this.allCoupons.push({
                  name: code,
                  id: coupon.id,
                });
              });
            }
          });

          this.allCoupons = Array.from(
            new Map(this.allCoupons.map((item) => [item.name, item])).values()
          ).sort((a, b) => a.name.localeCompare(b.name));

          // ✅ Initialize both lists
          this.allCouponsData = [...this.allCoupons];
          this.filteredCoupons = [...this.allCoupons];

        }
      });
    } catch (error) {
      console.error('Error fetching coupons:', error);
    }
  }


  getDataList() {
    this.page = this.page < 0 ? 0 : this.page;
    this.rows = this.rows < 1 ? 10 : this.rows;

    const obj = {
      PageNo: this.page,
      PageSize: this.rows,
      filterValue: this._filterService.searchText,
      orderParam: this.orderParam,
      orderBy: this.orderBy,
    };

    this._abd.showSpinner();
    try {
      this.salesChannelServices
        .getAllSalesChannel(obj).pipe(
        catchError(err => {
          console.error('Failed to fetch sales channels:', err);
          this._connMessageService.showToastMessage('Error fetching channels.', 'error');
          return of({ success: false, data: [] });
        }),
        finalize(() => this._abd.hideSpinner())
      )
        .subscribe((res) => {
          if (res.success) {
            this.totalRecords = res.totalRecords;
            let dataList = res.data;
            let startFrom = this.page * this.rows + 1;
                  this.dataList = res.data.map((value, index) => {
          // 🧩 Extract coupon names
          const couponsArray = Array.isArray(value.salesChannelCoupon)
            ? value.salesChannelCoupon.map(c => c.couponCode).filter(Boolean)
            : [];

          const couponsDisplay =
            couponsArray.length > 0
              ? couponsArray.join(', ')
              : '—'; // dash if no coupon

          return {
            index: index + startFrom,
            fullName: value.fullName,
            status: value.status ? 'Enabled' : 'Disabled',
            couponsDisplay,
            ...value,
          };
        });

             this.masterDataList = [...this.dataList];
            this._abd.hideSpinner();
          }
        });

      this._filterService.updateFilters(this._globals.componentName, obj);
      this._filterService.updatePages(this._globals.componentName, {
        page: this.page,
        rows: this.rows,
      });
    } catch {
      this._abd.hideSpinner();
    }
  }

  ngOnDestroy() {
    this._globals.componentName = '';
  }

  refrestDataList(e: any) {
    this.getDataList();
  }
  checkIfChannelUse() {
    this.optionDeleteClicked();
    //   this._abd.showSpinner()
    //   setTimeout(() => {
    //     this._abd.hideSpinner()
    //     this.optionDeleteClicked()
    //   }, 3000);
    //   let obj = {
    //     "channelName":this.salesChannelServices.activeItem.fullName,
    //   }
    //   this.couponCodeServices.getAllCouponCodes(obj).subscribe(res => {
    //     if (res.success) {

    //    }
    //  })
  }
  optionDeleteClicked() {
    this.op.hide();
    this._confirmationService.confirm({
      message:
        'Deleting process causes permanent loss of information. Are you sure to proceed',
      header: 'Delete Confirmation',
      icon: 'pi pi-info-circle',
      accept: () => {
        this._abd.showSpinner();
        try {
          this.salesChannelServices
            .deleteChannel(this.salesChannelServices.activeItem.id)
            .pipe(finalize(() => this._abd.hideSpinner()))
            .subscribe((res) => {
              if (res.success) {
                this.getDataList();
                this._connMessageService.showToastMessage(
                  `Sales channel deleted successfully.`,
                  'success'
                );
                 this._filterService.searchText = ""
              }
              this.getAllCoupons();
            });
        } catch {
          this._abd.hideSpinner();
        }
      },
      reject: () => { },
    });
  }
  actionButtonClick(item: any) {
    this.salesChannelServices.activeItem = JSON.parse(JSON.stringify(item));
  }
  editButtonClicked() {
    this.isViewOnly = false;
    this.salesChannelServices.showEditChannel = true;
  }

  callbackFuncFromFilter(event) {
    this.getDataList();
  }

  filterButtonPressed() {
    this.getDataList();
  }

  onPageChange(e) {
    this.page = e.page;
    this.rows = e.rows;
    this._abd.setOptionToLocalStorage(
      this._globals.componentName,
      'last-page',
      e.page
    );

    this.getDataList();
  }

  // ────────────────────────────────────────────────
  exportExcel(): void {
    try {
      this._abd.exportExcel(this.dataList, this.colHeader[0], this.colflds, 'Sales Channel', false);
    } catch (err) {
      console.error('Excel export failed:', err);
      this._connMessageService.showToastMessage('Export failed.', 'error');
    }
  }

  exportPdf(): void {
    try {
      this._abd.exportPdf(this.dataList, this.colHeader, this.colflds, 'Sales Channel');
    } catch (err) {
      console.error('PDF export failed:', err);
      this._connMessageService.showToastMessage('PDF export failed.', 'error');
    }
  }

  onRowSelect(e) {
    this.isViewOnly = true;
    this.salesChannelServices.activeItem = JSON.parse(
      JSON.stringify(e.data)
    );
    this.salesChannelServices.showEditChannel = true;
  }
  customSort(e) {
    const last = this.orderParam;
    switch (e.sortField) {
      case 'fullName':
        this.orderParam = 'fullName';
        break;
      case 'status':
        this.orderParam = 'status';
        break;

      default:
        this.orderParam = '';
    }
    if (this.orderParam !== '') {
      this.orderBy = e.sortOrder == 1 ? 'asc' : 'desc';
      if (last !== this.orderParam) this.orderBy = 'asc';
      this.getDataList();
    }
  }

  // Triggered when user types in autocomplete
  filterCoupons(event: any) {
    const query = event.query.toLowerCase();

    console.log('Filtering coupons with query:', this.allCoupons, query);
    this.filteredCoupons = this.allCoupons
      .filter(coupon =>
        coupon.name.toLowerCase().includes(query) &&
        !this.assignedCoupons.some(ac => ac.name === coupon.name)
      )
      .map(coupon => ({ ...coupon, disabled: false }));
  }

  // Add selected coupon to list
  addCoupon(coupon: any, couponAuto: any) {
    if (!coupon || coupon.disabled) return;

    const alreadyAdded = this.assignedCoupons.some(ac => ac.id === coupon.id);
    if (!alreadyAdded) {
      this.assignedCoupons.push({ id: coupon.id, name: coupon.name, status: 'new' });
      this.addedCoupons.push({ id: coupon.id, name: coupon.name });
      this.hasChanges = true;
    }
    this.filteredCoupons = this.filteredCoupons.map(c =>
      c.id === coupon.id ? { ...c, disabled: true } : c
    );
    this.selectedCoupon = null;
    couponAuto.inputEL.nativeElement.value = '';
  }

  removeCoupon(index: number) {
    const removed = this.assignedCoupons[index];
    if (!removed) return;

    // mark deleted if it was previously saved
    if (removed.status === 'saved') {
      removed.status = 'deleted';
      this.removedCoupons.push(removed);
    } else {
      // it was newly added → simply drop it
      this.addedCoupons = this.addedCoupons.filter(a => a.id !== removed.id);
    }

    // remove from visible list
    this.assignedCoupons.splice(index, 1);
    this.hasChanges = true;

    // enable again in dropdown
    this.filteredCoupons = this.filteredCoupons.map(c =>
      c.id === removed.id ? { ...c, disabled: false } : c
    );
  }

  saveAssignedCoupons() {
    const added = this.assignedCoupons.filter(c => c.status === 'new');
    const removed = this.originalCoupons.filter(c =>
      !this.assignedCoupons.some(ac => ac.discountId === c.discountId)
    );
    if (added.length === 0 && removed.length === 0) {
      console.log('No changes detected.');
      this.showAssignCouponDialog = false;
      this.hasChanges = false;
      return;
    }
    // start spinner
    this._spinner.show();
    const payload = {
      salesChannelId: this.selectedChannel.id,
      addedCoupons: added.map(c => ({
        discountId: c.id,
        couponCode: c.name
      })),
      removedCouponIds: removed.map(r => r.discountId)
    };


    this.couponCodeServices.updateChannelCoupons(payload).pipe(
      catchError(err => {
        console.error('Update coupons failed:', err);
        this._connMessageService.showToastMessage('Error updating coupons.', 'error');
        return of({ success: false });
      }),
      finalize(() => this._spinner.hide())
    ).subscribe({
      next: (res) => {
        this._spinner.hide();
        if (res.success) {

          this._connMessageService.showToastMessage(
            `Coupons updated successfully!`,
            'success'
          );
          // refresh baseline: mark all as saved again
          this.assignedCoupons = this.assignedCoupons.map(c => ({ ...c, status: 'saved' }));
          this.originalCoupons = JSON.parse(JSON.stringify(this.assignedCoupons));
          this.getDataList();
        }
        else {
          this.errorMessage = res.message || 'Failed to update coupons.';
          // this._connMessageService.showToastMessage(
          //   res.message || 'Failed to update coupons.',
          //   'error'
          // );
        }
        this.showAssignCouponDialog = false;
        this.hasChanges = false;
      },
      error: (err) => {
        this._spinner.hide();
         this.errorMessage = 'An error occurred while updating coupons.';
        // this._connMessageService.showToastMessage(
        //   'An error occurred while updating coupons.',
        //   'error'
        // );
      }
    });
  }



  // Called when user clicks "Assign Coupon" from action menu
  assignCoupon(item: any) {
    this.selectedChannel = item;
    this.showAssignCouponDialog = true;

    // coupons that already exist on this channel
    this.assignedCoupons = (item.salesChannelCoupon || []).map((c: any) => ({
      id: c.id,
      discountId: c.discountId,
      name: c.couponCodesList?.[0] || c.couponCode || c.name || '',
      status: 'saved'       // <── existing record
    }));

    this.originalCoupons = JSON.parse(JSON.stringify(this.assignedCoupons));

    this.allCoupons = [...this.allCouponsData];
    this.filteredCoupons = this.allCoupons
      .filter(c => !this.assignedCoupons.some(ac => ac.name === c.name))
      .map(c => ({ ...c, disabled: false }));

    this.addedCoupons = [];
    this.removedCoupons = [];
    this.hasChanges = false;
  }




  showAssignCouponsDialog(channel: any) {
    this.selectedChannel = channel;

    // ✅ Load previously assigned coupons
    this.assignedCoupons = [];
    if (channel.salesChannelCoupon && channel.salesChannelCoupon.length > 0) {
      this.assignedCoupons = channel.salesChannelCoupon.map((c: any) => ({
        id: c.id,
        discountId: c.discountId,
        name: c.name || c.couponCode || c.couponCodesList?.[0],
      }));
    }

    // ✅ Filter list to disable already-selected ones
    this.filteredCoupons = this.allCoupons.map((c) => ({
      ...c,
      disabled: this.assignedCoupons.some((ac) => ac.id === c.id),
    }));

    // ✅ Show the popup
    this.showAssignCouponDialog = true;
  }

  cancelAssignCouponDialog() {
    if (this.hasChanges) {
      const confirmLeave = confirm(
        `⚠️ You have unsaved changes:\n\n` +
        `• Added: ${this.addedCoupons.length}\n` +
        `• Removed: ${this.removedCoupons.length}\n\n` +
        `Are you sure you want to close without saving?`
      );

      if (!confirmLeave) return; // stay in popup
    }

    this.showAssignCouponDialog = false;
  }

  showAllCoupons(item: any, event?: MouseEvent) {
    if (event) event.stopPropagation(); // ✅ prevent table row / overlay triggers
    this.selectedCoupons = item.salesChannelCoupon || [];
    this.showAllCouponsDialog = true;
  }
}
